import { Turbo } from "@hotwired/turbo-rails";

Turbo.StreamActions.redirect = function() {
  window.Turbo.visit(this.getAttribute("target"));
};
